
class StoreFrontAPI {
    static instance = new StoreFrontAPI();
    client;
    constructor() {
        // setTimeout(() => {
        //     console.log(ShopifyStorefrontAPIClient.createStorefrontApiClient);

        // }, 1000)
        // this.client = ShopifyStorefrontAPIClient.createStorefrontApiClient({
        //     storeDomain: 'https://hilxeyewear-dev.myshopify.com',
        //     apiVersion: '2024-07',
        //     publicAccessToken: 'e02056439a71d9713f03414484f7f571',
        //     customFetchApi: fetch
        // });
        this.intervalInit = setInterval(() => {
            this.init();

        }, 100)
    }
    init() {

        if (this.client == undefined && ShopifyStorefrontAPIClient != undefined) {
            this.client = ShopifyStorefrontAPIClient.createStorefrontApiClient(
                Object.assign(window.StoreAPIConfig || {}, {
                    customFetchApi: fetch
                })
            );
            clearInterval(this.intervalInit)
        }
    }
    async removeDiscount(discountCode) {
        var discounts = await this.getDiscountCodes();
        discounts = discounts.map(el => el.code).filter(el => el != discountCode);
        var resdiscountCodes = await this.updateDiscounts(discounts);
        var resDiscount = resdiscountCodes.find(el => el.code == discountCode)
        if (!resDiscount) {
            return true;
        } else {
            return false;
        }
    }
    async applyDiscount(discountCode) {
        var discounts = await this.getDiscountCodes();
        var preDiscount = discounts.slice().map(el => el.code)
        discounts = [discountCode, ...discounts.map(el => el.code)];
        var resdiscountCodes = await this.updateDiscounts(discounts);
        console.log(resdiscountCodes);
        var resDiscount = resdiscountCodes.find(el => el.code == discountCode)
        // alert(resDiscount)
        if (resDiscount && resDiscount.applicable) {
            // alert("Valid")
            return true;

        } else {
            await this.updateDiscounts(preDiscount)
            // alert("InValid") 
            return false;

        }
    }
    async updateDiscounts(discounts) {
        var cartID = this.getCartID();
        var cmd = `mutation cartDiscountCodesUpdate($cartId: ID!, $discountCodes: [String!]) {
  cartDiscountCodesUpdate(cartId: $cartId, discountCodes: $discountCodes) {
    cart {
      id
      discountCodes{
      code
      applicable
      }
      estimatedCost{
            totalAmount{
                amount
            }
      }

    }
    userErrors {
      field
      message
    }
  }
}`
        const { data, errors, extensions } = await this.client.request(cmd, {
            variables: {
                "cartId": cartID,
                "discountCodes": discounts
            }
        })
        if (data?.cartDiscountCodesUpdate && data?.cartDiscountCodesUpdate.cart) {
            const cart = data.cartDiscountCodesUpdate.cart;
            var discountCodes = cart.discountCodes;
            return discountCodes;
        }
        return [];

    }
    async getDiscountCodes() {
        var cartID = this.getCartID();
        var cmd = `{
  cart(id:"${cartID}") {
      id
      discountCodes{
      code
      applicable
      }
      estimatedCost{
            totalAmount{
                amount
            }
      }
  }
}`

        const { data, errors, extensions } = await this.client.request(cmd, {})
        if (data && data.cart) {
            var discountCodes = data.cart.discountCodes
            return discountCodes;
        }
        return [];
    }


    getCartID() {
        var cartID = "gid://shopify/Cart/" + decodeURIComponent(this.getCookie("cart"));
        return cartID
    }
    getCookie(name) {
        var match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
        if (match) return match[2];
    }
}
window.StoreFrontAPI = StoreFrontAPI